var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import { Input } from "../Input/Input";
import i18next from "i18next";
import { Flex } from "../../Flex";
import { Button, ErrorText } from "..";
import styled from "styled-components";
import { Loader } from "../../Loader/Loader";
import { SVG } from "../../../classConstants";
var defaultProps = {
    minLength: 0,
};
var factory = function () {
    var InputWithSubmit = /** @class */ (function (_super) {
        __extends(InputWithSubmit, _super);
        function InputWithSubmit() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.unmounted = false;
            _this.acRef = React.createRef();
            _this.state = {
                loading: false,
            };
            _this.handleChange = function (x) {
                _this.props.onChange(x.currentTarget.value);
            };
            _this.handleSubmit = function (e) { return __awaiter(_this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            this.setState({ loading: true });
                            return [4 /*yield*/, this.props.onSubmit(e)];
                        case 1:
                            _a.sent();
                            this.setStateIfMounted({ loading: false });
                            return [2 /*return*/];
                    }
                });
            }); };
            return _this;
        }
        Object.defineProperty(InputWithSubmit.prototype, "isButtonDisabled", {
            get: function () {
                return this.props.buttonDisabled || this.state.loading || this.props.minLength > this.props.value.length;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(InputWithSubmit.prototype, "inputProps", {
            get: function () {
                var _a = this.props, error_message = _a.error_message, wrapperClassName = _a.wrapperClassName, label = _a.label, submitLabel = _a.submitLabel, onSubmit = _a.onSubmit, buttonClassName = _a.buttonClassName, buttonDisabled = _a.buttonDisabled, leftIcon = _a.leftIcon, rightIcon = _a.rightIcon, props = __rest(_a, ["error_message", "wrapperClassName", "label", "submitLabel", "onSubmit", "buttonClassName", "buttonDisabled", "leftIcon", "rightIcon"]);
                return __assign(__assign({}, props), { input: { name: props.name || "input_with_submit", }, onChange: this.handleChange, disabled: this.state.loading });
            },
            enumerable: false,
            configurable: true
        });
        InputWithSubmit.prototype.setStateIfMounted = function (object, callback) {
            if (this.unmounted) {
                return;
            }
            this.setState(object, callback);
        };
        InputWithSubmit.prototype.componentWillUnmount = function () {
            this.unmounted = true;
        };
        InputWithSubmit.prototype.getSubmitButtonLabel = function () {
            var _a = this.props, submitLabel = _a.submitLabel, leftIcon = _a.leftIcon, rightIcon = _a.rightIcon;
            submitLabel = (leftIcon || rightIcon || submitLabel) ? submitLabel : i18next.t("common.apply");
            return (React.createElement(React.Fragment, null, submitLabel));
        };
        InputWithSubmit.prototype.render = function () {
            var _a = this.props, error_message = _a.error_message, wrapperClassName = _a.wrapperClassName, leftIcon = _a.leftIcon, rightIcon = _a.rightIcon, buttonClassName = _a.buttonClassName;
            return (React.createElement(React.Fragment, null,
                React.createElement(React.Fragment, null, !error_message ? null : React.createElement(ErrorText, { error: error_message })),
                React.createElement(Wrap, { className: wrapperClassName },
                    React.createElement(InputWrap, { isInline: false, className: wrapperClassName + "-input-wrapper" },
                        React.createElement(Input, __assign({}, this.inputProps)),
                        this.state.loading && React.createElement(Spinner, null)),
                    React.createElement(ApplyButton, { className: buttonClassName, disabled: this.isButtonDisabled, leftIcon: leftIcon, rightIcon: rightIcon, type: "button", label: this.getSubmitButtonLabel(), onClick: this.handleSubmit }))));
        };
        InputWithSubmit.defaultProps = defaultProps;
        return InputWithSubmit;
    }(React.Component));
    var ApplyButton = styled(Button)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n        ", "\n\n        .", " { display: block; }\n\n        display: flex;\n        gap: 10px;\n        align-items: center;\n\n        padding: 0;\n        padding-left: var(--ws-coupon-code-apply-padding);\n        padding-right: var(--ws-coupon-code-apply-padding);\n    "], ["\n        ",
        "\n\n        .", " { display: block; }\n\n        display: flex;\n        gap: 10px;\n        align-items: center;\n\n        padding: 0;\n        padding-left: var(--ws-coupon-code-apply-padding);\n        padding-right: var(--ws-coupon-code-apply-padding);\n    "])), function (_a) {
        var disabled = _a.disabled;
        return !disabled ? "" : "\n            pointer-events: none;\n        ";
    }, SVG);
    var Wrap = styled(Flex)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n        --ws-input-margin: 0;\n    "], ["\n        --ws-input-margin: 0;\n    "])));
    var InputWrap = styled(Flex)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n        position: relative;\n        align-self: stretch;\n        flex: 1;\n        .ws-input {\n            padding-right: 24px !important;\n        }\n\n        div, label {\n            display: flex;\n            flex-direction: column;\n            flex: 1;\n        }\n\n        input {\n            height: 100%;\n        }\n    "], ["\n        position: relative;\n        align-self: stretch;\n        flex: 1;\n        .ws-input {\n            padding-right: 24px !important;\n        }\n\n        div, label {\n            display: flex;\n            flex-direction: column;\n            flex: 1;\n        }\n\n        input {\n            height: 100%;\n        }\n    "])));
    var Spinner = styled(Loader)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n        position: absolute;\n        top: 0;\n        right: 0;\n        width: 24px;\n        height: 100%;\n        &:before{\n            border-width: 2px;\n            width: 16px;\n            height: 16px;\n            margin-top: -8px;\n            margin-left: -50%;\n        }\n    "], ["\n        position: absolute;\n        top: 0;\n        right: 0;\n        width: 24px;\n        height: 100%;\n        &:before{\n            border-width: 2px;\n            width: 16px;\n            height: 16px;\n            margin-top: -8px;\n            margin-left: -50%;\n        }\n    "])));
    return InputWithSubmit;
};
export var InputWithSubmit = factory();
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
